import styled from '@emotion/styled';
import { ViewType } from '../../types';
import { headerButtonView } from '../HeaderButtons/buttonsView';

export const Container = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export function getExtraDimHeaderButton(view: ViewType) {
  switch (view) {
    case 'white':
      return headerButtonView['white'];

    case 'black':
      return headerButtonView['black'];

    default:
      return 'extra-dim';
  }
}

export function getPrimaryDimHeaderButton(view: ViewType) {
  switch (view) {
    case 'white':
      return headerButtonView['white-dim'];

    case 'black':
      return headerButtonView['black-dim'];

    default:
      return 'primary-dim';
  }
}
